import React from 'react'
import { cn } from '@/lib/utils'

export const DropdownCategoryTitle = ({
  children,
}: {
  children: React.ReactNode
}) => {
  return (
    <div className='text-foreground mb-1 px-1.5 text-[.65rem] font-semibold uppercase'>
      {children}
    </div>
  )
}

export const DropdownButton = React.forwardRef<
  HTMLButtonElement,
  {
    children: React.ReactNode
    isActive?: boolean
    onClick?: () => void
    disabled?: boolean
    className?: string
  }
>(function DropdownButtonInner(
  { children, isActive, onClick, disabled, className },
  ref
) {
  const buttonClass = cn(
    'flex items-center gap-2 p-1.5 text-sm font-medium text-foreground/90 text-left bg-transparent w-full rounded-sm',
    !isActive && !disabled,
    'hover:bg-neutral-100 hover:text-neutral-800 dark:hover:bg-neutral-900 dark:hover:text-neutral-200',
    isActive &&
      !disabled &&
      'bg-neutral-100 text-neutral-800 dark:bg-neutral-900 dark:text-neutral-200',
    disabled && 'text-neutral-400 cursor-not-allowed dark:text-neutral-600',
    className
  )

  return (
    <button
      className={buttonClass}
      disabled={disabled}
      onClick={onClick}
      ref={ref}
    >
      {children}
    </button>
  )
})
